import { useMemo } from 'react'

import { TicketsResponse } from 'types'

export const useTicketResponseData = (ticketsResponse?: TicketsResponse) => {
  return useMemo(() => {
    if (!ticketsResponse) {
      return {
        tickets: [],
        ticketCount: 0,
      }
    }
    if ('items' in ticketsResponse) {
      return {
        tickets: ticketsResponse.items,
        ticketCount: ticketsResponse.count,
      }
    }

    return {
      tickets: ticketsResponse,
      ticketCount: ticketsResponse.length,
    }
  }, [ticketsResponse])
}
